import React, { Component } from 'react';
import DriverForm from './DriverForm';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {updateTitle} from '../SectionTitle/actions';
import { initializeDriver } from './actions';
import store from './store';

const mapStateToProps = (state) => {
    //
    return {
        state: state
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateTitle: (titleObject) => dispatch(updateTitle(titleObject)),
        initializeDriver: (data) => dispatch(initializeDriver(data)),
    }
}

class DriverContainer extends Component {
    constructor(){
        super();
        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.updateTitle({
            title: '<h1>Reviewing Driver</h1>',
            subTitle: ` 
            <div><span class="estimateMonths">$${this.props.state.userConfirmation.estimate}</span> for 6 months</div>
            `,
            image: '<i class="fa fa-id-card-o" aria-hidden="true"></i>'
        });
    }

    prevPage(){
        const {history} = this.props;
        history.goBack();
    }

    nextPage(id, subjects) {
        //window.scrollTo(0, 0);
        const length = subjects.length - 1;
        id = ++id;
        console.log(id);

        const {history} = this.props;

        if (id <= length) {
            window.scrollTo(0, 0);
            history.push(`/driver/${id}`);

        }
        else {
            //window.scrollTo(0, 0);
            history.push(`/vehicle/0`);
        }

    }

    getDriverData(subjects, index) {
        //const DriverSchema = this.props.initializeDriver(subjects[index]);
        const updatedDriver = {
            ...store,
            ...subjects[index]
        }
        console.log(updatedDriver);
        return updatedDriver;
    }

    render() {
        const { driver } = this.props.state.form;
        if (this.props.state.ReviewReducer.reviewData === undefined) {
            return (
                <Redirect to='/' />
            )
        }
        else {
            //const { props } = this;
            const { id } = this.props.match.params;
            const { subjects } = this.props.state.ReviewReducer.reviewData;
            //const { subjects } = this.props.state.ReviewReducer.reviewData;
            const currentDriver = this.getDriverData(subjects, id);
            //const nextPage = this.nextPage(id, subjects);
            const driverForm = this.props.state;
            console.log(driverForm);
            //const nextPage = '/driver'
            return (
                <div>
                    <DriverForm
                        driverForm={driver}
                        onPrevPage={this.prevPage}
                        onNextPage={()=>this.nextPage(id,subjects)}
                        currentDriver={currentDriver} />
                </div>
            );
        }

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverContainer);


// WEBPACK FOOTER //
// ./src/Driver/index.js